module.exports = __webpack_public_path__ + "static/media/socialwall.ea318027.png";


/*****************
 ** WEBPACK FOOTER
 ** ./assets/images/screenshots/socialwall.png
 ** module id = 435
 ** module chunks = 0
 **/